export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10149.8bf65165.jpg";